<template>
  <div class="profile-dropdown-wrapper">
    <a href="#">
      <UserProfileAvatar :name="profileDisplayName" :photo="profilePhoto" class="header-profile-avatar"/>
    </a>

    <div ref="dropdownRef" class="dropdown-notifications small"
         uk-dropdown="pos: top-right;mode:click; animation: uk-animation-slide-bottom-small">
      <a href="#">
        <div class="dropdown-user-details">
          <div class="dropdown-user-avatar">
            <UserProfileAvatar :name="profileDisplayName" :photo="profilePhoto" class="dropdown-profile-avatar"/>
          </div>
          <div class="dropdown-user-name">
            {{ userInfo?.name }} {{ userInfo?.surname }}
            <span>{{ userInfo?.company_name }}</span>
          </div>
        </div>
      </a>

      <ul class="dropdown-user-menu">
        <li v-if="!isSubCompanySelected">
          <a @click="navigateTo('user.index')">
            <i class="uil-user-circle"></i> {{ $t('general.log_in_as_user') }}
          </a>
        </li>
        <li v-else>
          <a href="#" @click.prevent="$emit('go-to-main-company')">
            <i class="uil-building"></i>
            {{ $t('general.log_in_as_user_from_main_company') || 'Giriş yapmak için Ana Kurum\'a geçin' }}
          </a>
        </li>
        <li v-if="$hasPermission('read_companysetting')">
          <a @click="navigateTo('company.setting')">
            <i class="icon-feather-settings"></i> {{ $t('general.settings') }}
          </a>
        </li>
        <li class="menu-divider"></li>
        <li>
          <a @click="navigateTo('User.faq')">
            <i class="icon-feather-help-circle"></i> {{ $t('general.faq') }}
          </a>
        </li>
        <li>
          <a href="#" @click.prevent="$emit('logout')">
            <i class="icon-feather-log-out"></i> {{ $t('general.log_out') }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UserProfileAvatar from "@/view/components/common/UserProfileAvatar.vue";

export default {
  name: "CompanyProfileDropdown",
  components: {
    UserProfileAvatar,
  },
  props: {
    userInfo: {
      type: Object,
      default: null,
    },
    isSubCompanySelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    profileDisplayName() {
      return (
        [this.userInfo?.name, this.userInfo?.surname].filter(Boolean).join(" ") ||
        this.userInfo?.fullname ||
        ""
      );
    },
    profilePhoto() {
      return this.userInfo?.photo || this.userInfo?.photo_link || "";
    },
  },
  methods: {
    hide() {
      if (this.$refs.dropdownRef) {
        UIkit.dropdown(this.$refs.dropdownRef).hide(0);
      }
    },
    navigateTo(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
      this.hide();
    },
  },
};
</script>

<style scoped>
.header-profile-avatar,
.dropdown-profile-avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  font-size: 13px;
}

.profile-dropdown-wrapper >>> .dropdown-notifications.small {
  width: 280px !important;
}

.profile-dropdown-wrapper >>> .dropdown-user-details {
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 4px;
}

.profile-dropdown-wrapper >>> .dropdown-user-name {
  color: #1f2937 !important;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 1.4;
}

.profile-dropdown-wrapper >>> .dropdown-user-name span {
  color: #6b7280 !important;
  font-size: 12px !important;
  font-weight: 500;
}

/* Mobil: Dropdown ekran dışına taşmasın */
@media (max-width: 640px) {
  .profile-dropdown-wrapper >>> .dropdown-notifications.small {
    position: fixed !important;
    top: 56px !important;
    right: 8px !important;
    left: auto !important;
    width: calc(100vw - 16px) !important;
    max-width: 300px !important;
  }

  .profile-dropdown-wrapper >>> .dropdown-notifications.small:before {
    display: none;
  }

  .profile-dropdown-wrapper >>> a .header-profile-avatar {
    width: 32px !important;
    height: 32px !important;
    min-width: 32px;
    font-size: 11px;
  }
}
</style>
